module.exports = __webpack_public_path__ + "img/aParty_032523_A.1216fb8d.jpg";